import InfoWithTooltip from 'components/InfoWithTooltip/InfoWithTooltip';
import EXTERNAL_URLS from 'constants/externalUrls';
import makeStyles from '@material-ui/styles/makeStyles';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles({
  root: { marginLeft: '5px' },
});

const LanguageSettingsBreadcrumbAdditionalContent = () => {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <InfoWithTooltip
      className={classes.root}
      title={t('common.mainMenu.languageSettings.tooltip')}
      link={EXTERNAL_URLS.languageSettings}
      size="m"
    />
  );
};

export default LanguageSettingsBreadcrumbAdditionalContent;
